<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PopupMessage',
  props: {},
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
      titlePopup: 'Popups/titlePopup',
    }),

    isPopupMessage() {
      return this.checkIfOverlayInList('popup-message');
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
    }),

    closePopupMessage() {
      this.togglePopup('popup-message');
    },
    checkIfOverlayInList(overlayName) {
      return this.allShowedOverlays?.includes(overlayName);
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isPopupMessage }"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between w-full">
          <p
            v-html="titlePopup ? titlePopup : 'Ваша заявка успешно отправлена!'"
            class="title-h2 mb-6 pr-2"
          ></p>
          <div
            class="popup-new__close mb-3.5 md:mb-7"
            @click="closePopupMessage"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>